








































































































import Vue from "vue";
import { $eventsBus } from "@/main";
import BaseSimpleSlider from "@/app/shared/components/base/BaseSimpleSlider.vue";
import BaseVideoRangeSlider from "@/app/shared/components/base/BaseVideoRangeSlider.vue";
import BaseCheckbox from "@/app/shared/components/base/BaseCheckbox.vue";
import BaseInput from "@/app/shared/components/base/BaseInput.vue";

export default Vue.extend({
  name: "DurationController",
  components: {
    BaseSimpleSlider,
    BaseVideoRangeSlider,
    BaseCheckbox,
    BaseInput,
  },
  data: function () {
    return { opacity: 1 };
  },
  props: {
    isMultiSelectMode: {
      type: Boolean,
    },
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    videoSpeed: {
      // getter
      get: function () {
        return this.$store.state.selectedItem.currentVariation.speed;
      },
      // setter
      set: function (newValue) {
        this.$store.state.selectedItem.currentVariation.speed = newValue;
      },
    },
  },
  watch: {
    previewItem: function () {
      this.checkAndUpdatePreviewItemThumbs();
    },
  },
  mounted() {
    this.checkAndUpdatePreviewItemThumbs();
  },
  methods: {
    changeDuration(value) {
      const minSpeed = 0.5;
      const maxSpeed = 3;

      this.videoSpeed =
        Math.round(
          ((this.previewItem.currentVariation.cut.finishTime -
            this.previewItem.currentVariation.cut.startTime) /
            value) *
            10000
        ) / 10000;

      if (this.videoSpeed < minSpeed) {
        this.videoSpeed = minSpeed;
      }

      if (this.videoSpeed > maxSpeed) {
        this.videoSpeed = maxSpeed;
      }

      this.previewItem.currentVariation.recalcFileOutputParameters();

      this.updateAllOverlay(this.previewItem.currentVariation.overlays);
      this.$store.commit("addNewStateToHistory");
    },

    updateAllOverlay(overlays) {
      overlays.forEach((overlay) => {
        if (overlay.type === "animation") {
          $eventsBus.$emit(
            "updateAllDurationForAnimation",
            overlay,
            this.videoSpeed
          );
          $eventsBus.$emit("updateAnimation", overlay.id);
        }
      });
    },
    changeCheckedItems(isSpeed) {
      if (!this.previewItem.currentVariation.checked) {
        return;
      }
      this.items.forEach((item) => {
        item.variations.forEach((v) => {
          if (!v.checked || v === this.previewItem.currentVariation) {
            return;
          }
          if (isSpeed) {
            v.speed = this.previewItem.currentVariation.speed;
            v.recalcFileOutputParameters();
            this.updateAllOverlay(v.overlays);
          }
        });
      });
    },
    checkAndUpdatePreviewItemThumbs() {
      if (!this.previewItem || !this.previewItem.fileId) {
        setTimeout(() => {
          this.checkAndUpdatePreviewItemThumbs();
        }, 1000);
        return;
      }
      if (!this.previewItem.thumbs || this.previewItem.thumbs.length === 0) {
        this.axios
          .post(
            "/utils/getThumbs",
            {
              sessionId: this.$store.state.userInfo.sessionId,
              fileId: this.previewItem.fileId,
            },
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            if (
              JSON.parse(response.config.data).fileId !==
              this.previewItem.fileId
            ) {
              this.checkAndUpdatePreviewItemThumbs();
              return;
            }
            this.previewItem.thumbs = response.data;
          });
      }
    },
    /*     startDrag() {
      $eventsBus.$emit("stopPlayContent");
    },
    changeDuration(time) {
      $eventsBus.$emit("changePreviewTime", time);
    },
    stopDrag(startTime) {
      $eventsBus.$emit("startPlayContent", startTime);
    }, */
  },
});
